import './Navigation.css';
import {Link} from "react-router-dom";

function Navigation() {
    return (
        <nav className="navigation-container">
            <div className="navigation-content">
                <ul aria-label="Hauptnavigation">
                    <li className="nav-link">
                        <Link to="/" aria-label="Zur Anmeldung" tabIndex="0">Anmeldung</Link>
                    </li>
                    <li className="nav-link">
                        <Link to="/kontakt" aria-label="Zur Kontaktseite" tabIndex="0">Kontakt</Link>
                    </li>
                </ul>
            </div>
        </nav>
    );
}

export default Navigation;
